import { useGet } from '../../HttpClient';
import { Schema } from '@app/models';
import { tenantHierarchyBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

const pillarCode = "tms";
 
export function useSchema({ categoryId }: { categoryId: string }) {
  const get = useGet(true, pillarCode);
  const getSchema = async (categoryId: string) =>
    get<Schema>(`${tenantHierarchyBaseUrl}/category-by-id/${categoryId}/schema`);
  return useQueryWithErrorHandling({
    queryKey: ['schema', categoryId],
    queryFn: async () => await getSchema(categoryId),
    enabled: !!categoryId,
  });
}
